import { render, staticRenderFns } from "./addressAdd.vue?vue&type=template&id=51a0a361&"
import script from "./addressAdd.vue?vue&type=script&lang=js&"
export * from "./addressAdd.vue?vue&type=script&lang=js&"
import style0 from "./addressAdd.vue?vue&type=style&index=0&id=51a0a361&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports